"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const names_enum_1 = require("./names.enum");
const strings = {
    subjects: {
        [names_enum_1.default.SCHEDULED_PAYMENTS]: 'Cron Job Scheduled-Payments',
        [names_enum_1.default.PAST_DUE_INSTALLMENTS]: 'Cron Job Past-Due Installments Summary',
        [names_enum_1.default.PAST_DUE_INVOICES]: 'Cron Job Past-Due Invoices Summary',
        cronDefault: 'Cron Job execution results summary',
    },
    templates: {
        [names_enum_1.default.SCHEDULED_PAYMENTS]: (successes, total) => `Scheduled Payments: ${successes} successful charges out of ${total} total installments`,
        [names_enum_1.default.PAST_DUE_INSTALLMENTS]: (successes, total) => `Past Due Installments: ${successes} successful updates out of ${total} total installments`,
        [names_enum_1.default.PAST_DUE_INVOICES]: (successes, total) => `Past Due Invoices: ${successes} successful updates out of ${total} total invoices`,
        cronDefault: () => `Cron Job execution results summary`,
    },
};
const cronTasks = {
    getSubject: (task) => strings.subjects[task] || strings.subjects.cronDefault,
    getTemplate: (task) => strings.templates[task] || strings.templates.cronDefault,
};
exports.default = cronTasks;
//# sourceMappingURL=strings.js.map